import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { mainTheme } from './theme/Theme';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { GlobalStyles } from '@mui/material';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ThemeProvider theme={mainTheme}>
        <GlobalStyles
          styles={{
            "input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active":
            {
              WebkitBoxShadow: "0 0 0 1000px white inset !important",
              WebkitTextFillColor: "#000 !important",
              caretColor: "#000",
            },
          }}
        />
        <Provider store={store}>
          <App />
        </Provider>
      </ThemeProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
